export enum SubscriptionStatus {
  Active = 'Active',
  Inactive = 'Inactive'
}

export enum SubscriptionType {
  PECConnect = 'PECConnect',
  VerificationPackage = 'VerificationPackage'
}

export interface ISubscriptionPayload {
  id: string;
  subscriberId: string;
  subscriberType: 'Organization' | 'Employee';
  status: SubscriptionStatus;
  expirationDate: string;
  type: SubscriptionType;
}

export interface ISubscription extends ISubscriptionPayload {
  isExpiring: boolean;
  isExpired: boolean;
  typeDisplayName: string;
}

export enum PaymentStatus {
  Paid = 'Paid',
  Pending = 'Pending',
  Unpaid = 'Unpaid'
}
